import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RDSInstance, RDSMetrics } from '../../types/rds';

interface RDSState {
  selectedInstance: RDSInstance | null;
  instances: RDSInstance[];
  metrics: Record<string, RDSMetrics>;
  isLoading: boolean;
  error: string | null;
}

const initialState: RDSState = {
  selectedInstance: null,
  instances: [],
  metrics: {},
  isLoading: false,
  error: null,
};

const rdsSlice = createSlice({
  name: 'rds',
  initialState,
  reducers: {
    setSelectedInstance: (state, action: PayloadAction<RDSInstance | null>) => {
      state.selectedInstance = action.payload;
    },
    setInstances: (state, action: PayloadAction<RDSInstance[]>) => {
      state.instances = action.payload;
    },
    updateInstanceMetrics: (state, action: PayloadAction<{ instanceId: string; metrics: RDSMetrics }>) => {
      state.metrics[action.payload.instanceId] = action.payload.metrics;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSelectedInstance, setInstances, updateInstanceMetrics, setLoading, setError } = rdsSlice.actions;
export default rdsSlice.reducer;